export class LocationReq {
    sampleRequestItemId?: number;
}